import React from 'react';
import './Style.css';
import { UniversalLink } from '@plone/volto/components';

const cardServicoDefault = {
  icon: 'fas fa-cog',
  path: '/',
  title: 'Titulo do Serviço',
};

const CardService = ({ card }) => {
  const cardBuild = card || cardServicoDefault;

  return (
    <div className="card-service">
      <UniversalLink href={cardBuild.path}>
        <div className="card-content">
          <div className="icon-service">
            <i className={cardBuild.icon} aria-hidden="true"></i>
          </div>
          <div className="title-service">{cardBuild.title}</div>
        </div>
      </UniversalLink>
    </div>
  );
};

export default CardService;
